<template>
	<section class="page">
		<h1 v-if="currentPage.post_title">{{ currentPage.post_title }}</h1>
		<div class="content">
			<div class="content_left">
				<component
					v-for="(module, n) in currentPage.modules"
					:key="`module_${module.type}_${n}`"
					:is="module.type"
					v-bind="module"
				></component>
			</div>
			<div class="content_right">
				<div class="sticker">
					<section v-for="(m, i) in currentPage.media" :key="`media_${i}`">
						<h3 v-if="m.label">{{ m.label }}</h3>
						<div
							class="label"
							v-if="m.contact_form"
							@mouseenter="onPointerMouseEnter($event, 'text')"
							@mouseleave="onPointerMouseLeave($event, 'text')"
							v-html="m.contact_form"
						></div>
						<a
							v-if="m.email"
							:href="`mailto:${m.email}`"
							@mouseenter="onPointerMouseEnter($event, 'text')"
							@mouseleave="onPointerMouseLeave($event, 'text')"
							>{{ m.email }}</a
						>
						<a
							v-if="m.phone"
							:href="`tel:${filteredPhone(m.phone)}`"
							@mouseenter="onPointerMouseEnter($event, 'text')"
							@mouseleave="onPointerMouseLeave($event, 'text')"
							>{{ m.phone }}</a
						>
					</section>
				</div>
			</div>
		</div>
		<button
			type="button"
			class="back"
			@click="() => this.$router.push(`${redirectLang}`)"
			@mouseenter="onPointerMouseEnter"
			@mouseleave="onPointerMouseLeave"
		>
			<IconArrow fill="#000" />
			<span>{{ backLabel }}</span>
		</button>
	</section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import IconArrow from "@/components/icons/IconArrow";
import PointerHoverMixin from "@/mixins/pointerHover";
import EventBus from "@/helpers/event-bus";
// import ModuleContactForm from "../components/modules/ModuleContactForm.vue";

export default {
	name: "PageView",
	mixins: [PointerHoverMixin],
	props: {
		slug: String,
	},
	components: {
		IconArrow,
	},
	computed: {
		...mapState({
			currentLanguage: (state) => state.site.currentLanguage,
			defaultLanguage: (state) => state.site.defaultLanguage,
			source: (state) => state.site.from,
		}),
		...mapGetters("page", ["currentPage"]),
		redirectLang() {
			return this.currentLanguage === this.defaultLanguage
				? "/"
				: `/${this.currentLanguage}`;
		},
		title() {
			return this.currentPage.seotitle;
		},
		backLabel() {
			return this.source !== "home" ? "BACK" : "HOME";
		},
	},
	data() {
		return {
			post: false,
		};
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	methods: {
		filteredPhone(val) {
			if (val) {
				return val.replace(/tel:|Tel:|tel|Tel| |-|tel.|Tel./g, "");
			}

			return "";
		},
	},
	watch: {
		currentPage() {
			EventBus.$emit(EventBus.page.loaded);
		},
	},
};
</script>

<style lang="scss" scoped>
$time: 0.4s;
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
		// transform: scale(1)
	}

	33% {
		border-radius: 80% 70% 80% 70% / 80% 70% 100% 70%;
		// transform: scale(1.2)
	}

	66% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
		// transform: scale(1.4)
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

.page {
	@include mq($from: m) {
		padding-top: 100px;
	}

	@include mq($from: xl) {
		padding-top: 100px;
	}

	.content {
		display: flex;
		flex-wrap: wrap;
	}

	.content_left {
		&::v-deep > * {
			margin-left: 0;
			width: 100%;
		}

		&::v-deep .download > * {
			margin-left: 0;
			width: 100%;
		}

		&::v-deep a {
			transition: color 0.3s;
			&:hover {
				color: $colorRed1 !important;
			}
		}

		@include mq($from: m) {
			@include gridColumn(m, 15, 2, false, false);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 12, 3, false, false);
		}
	}

	.content_right {
		position: relative;

		@include mq($to: m) {
			margin-top: 50px;
			padding-top: 50px;
			width: 100%;

			&:after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;

				display: block;
				width: 100%;
				height: 1px;
				background: rgba($colorGraphite, 0.15);
			}
		}

		@include mq($from: m) {
			@include gridColumn(m, 6, 1, false, true);

			&:after {
				content: "";
				position: absolute;
				top: 0;
				left: -13.5%;

				display: block;
				width: 1px;
				height: 100%;
				background: rgba($colorGraphite, 0.15);
			}
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 7, 2, false, true);

			&:after {
				left: -15.5%;
			}
		}

		h3 {
			@include fontCopyS;
			margin-bottom: 5px;
		}

		.sticker {
			@include mq($from: m) {
				position: sticky;
				top: 150px;
			}

			@include mq($from: xl) {
				top: 220px;
			}
		}

		section {
			margin-top: 20px;

			&:first-child {
				margin-top: 0;
			}
		}

		a,
		.label {
			@include fontCopy;
			font-weight: 500;
		}

		a {
			transition: color 0.3s;
			&:hover {
				color: $colorRed1 !important;
			}
		}

		a,
		span {
			display: block;
		}
	}

	h1 {
		@include gridColumn(s, 12, 0, false, true);
		@include fontH0;

		@include mq($from: m) {
			@include gridColumn(m, 16, 1, false, true);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 14, 1, false, true);
		}
	}

	button {
		border: 0;
		background: #fff;
		box-shadow: none;
		appearance: none;
		-webkit-appearance: none;
		width: 65px;
		height: 62px;
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
		position: fixed;
		top: 65px;
		left: 10vw;
		z-index: 11;
		outline: none;
		cursor: pointer;
		transition: background $time, transform $time, opacity $time;
		animation: border1 2s infinite linear;
		animation-play-state: paused;
		transform: translateY(-40px);
		display: flex;
		align-items: center;
		justify-content: center;

		@include mq($from: m) {
			top: 90px;
			left: 72.5vw;
		}

		@include mq($from: l) {
			top: 70px;
			left: 72.5vw;
			width: 100px;
			height: 95px;
		}

		@include mq($from: xl) {
			top: 120px;
			left: 72.5vw;
		}

		@include mq($from: 2830px) {
			left: 72.5vw;
		}

		span {
			@include fontMenu;
			transition: color $time;
			font-size: 12px !important;
			margin: 0 0 0 10px !important;
		}

		&::v-deep {
			svg {
				transform: rotate(180deg);
			}

			svg path {
				transition: all $time;
			}
		}

		&:hover {
			animation-play-state: running;
			background: $colorRed1;

			span {
				color: #fff;
			}

			&::v-deep {
				svg path {
					fill: #fff;
				}
			}
		}
	}
}
</style>
